<template>
    <router-link
        class="news-card-link"
        :to="props.conferenceId ? `conference/${props.conferenceId}` : `news_page/${props.newsId}`"
        @mouseenter="handleHover"
        @mouseleave="handleMouseLeave"
    >
        <v-img
            class="news-card-image"
            :src="img_url"
            height="296px"
            cover
        >
            <div class="news-card-date-and-pin">
                <div class="news-card-date news-card-text">
                    {{ props.date }}
                </div>
                <svg
                    v-if="props.isPinned"
                    width="37"
                    height="36"
                    viewBox="0 0 37 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_2030_3729)">
                        <path
                            d="M21.7326 20.2886L27.0891 13.9049L27.8871 14.5745L29.2262 12.9786L21.2466 6.28285L19.9075 7.87878L20.7054 8.54835L15.3489 14.9321L12.4138 15.1888L11.0747 16.7848L15.2241 20.2665L11.2066 25.0543L12.4834 26.1256L16.5008 21.3378L20.6502 24.8196L21.9893 23.2237L21.7326 20.2886Z"
                            fill="#FF5151"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_2030_3729">
                            <rect
                                width="25"
                                height="25"
                                fill="white"
                                transform="translate(17) rotate(40)"
                            />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="news-card">
                <div class="news-card-text news-title">
                    <div
                        ref="shortTitleRef"
                        class="short-title"
                    >
                        {{ editTitle }}
                    </div>

                    <div
                        ref="fullTitleRef"
                        class="title-animation"
                    >
                        {{
                            props.title.length > 220
                                ? props.title.slice(0, 220).trim() + '...'
                                : props.title
                        }}
                    </div>
                </div>
            </div>
        </v-img>
    </router-link>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue'

const props = defineProps({
    newsId: Number,
    conferenceId: Number,
    url: String,
    title: String,
    date: String,
    isPinned: Boolean
})

const editTitle = ref(
    props.title.length > 42
        ? props.title.slice(0, 42).trim() + '...'
        : props.title
)
const fullTitleRef = ref(null)
const shortTitleRef = ref(null)
const isHovered = ref(false)

const img_url = computed(() => {
    return props.url === '/null'
        ? window.document.location.origin + '/img/background.jpeg'
        : window.document.location.origin + props.url
})

const handleHover = () => {
    isHovered.value = true

    const fullRect = fullTitleRef.value.getBoundingClientRect()
    const fullHeight = fullRect.height
    const shortRect = shortTitleRef.value.getBoundingClientRect()
    const shortHeight = shortRect.height
    fullTitleRef.value.style.marginTop =
        String((fullHeight - shortHeight) * -1) + 'px'
    fullTitleRef.value.style.opacity = 1
    shortTitleRef.value.style.opacity = 0
    fullTitleRef.value.animate(
        [
            { marginTop: 0 },
            { marginTop: String((fullHeight - shortHeight) * -1) + 'px' }
        ],
        {
            duration: 200
        }
    )
}

const handleMouseLeave = () => {
    isHovered.value = false

    const fullRect = fullTitleRef.value.getBoundingClientRect()
    const fullHeight = fullRect.height
    const shortRect = shortTitleRef.value.getBoundingClientRect()
    const shortHeight = shortRect.height
    fullTitleRef.value.style.marginTop = 0
    fullTitleRef.value.animate(
        [
            { marginTop: String((fullHeight - shortHeight) * -1) + 'px' },
            { marginTop: 0 }
        ],
        {
            duration: 200
        }
    )

    const setOpacity = () => {
        if (fullTitleRef.value !== null && shortTitleRef.value !== null) {
            fullTitleRef.value.style.opacity = 0
            shortTitleRef.value.style.opacity = 1
        }
    }

    setTimeout(setOpacity, 200)
}
</script>

<style lang="scss" scoped>
.news-title {
    z-index: 10;
    position: relative;
    width: 100% !important;
}

.short-title {
    padding: 1rem 1.5rem 2.4rem 1.5rem;
    width: 100%;
    background: #fff;
    color: #000 !important;
    min-height: 116.39px !important;
}

.title-animation {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    background: #fff;
    color: #000 !important;
    padding: 1rem 1.5rem 2.4rem 1.5rem;
    min-height: 116.39px !important;
    margin-top: 50px;
    width: 100%;
}
</style>
